// Configurações do site — preencha os placeholders com seus dados reais.

export const SITE = {
  brand: "kwai.ads",
  instagram: "@kwai.ads",
  instagramUrl: "https://www.instagram.com/kwai.ads",
  // Número do WhatsApp no formato internacional, apenas dígitos (ex.: 5511999999999)
  whatsappNumber: "5527997675535",
};

export function buildWhatsAppLink(message: string): string {
  return `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;
}